export { default } from './SimpleHero';
export type { Props as SimpleHeroProps } from './SimpleHero';
